import React from "react";
import CenteredMessage from "../components/CenteredMessage";

const NoPage = () => {
    return (<CenteredMessage>Pagina No Encontrada</CenteredMessage>)
}

export default NoPage;